/**
 * @component {"type":"ExtraInfoLauncher","version":"1.1"}
 * @component {"type":"ExtraInfoContent","version":"1.1"}
 */
define('component-extra-info',['knockout', 'helpers', 'training', 'user-answers'], function(ko, helpers, Training, UserAnswers) {

    return function(parentVM) {
        var self = this,
            entityVM = parentVM.entity,
            trainingVM = parentVM.training,
            training = new Training(),
            userAnswers = new UserAnswers();

        self.showContent = function(i, e) {
            var target = e.currentTarget,
                selector = (target.dataset) ? target.dataset.selector : '',
                tab = (selector) ? document.getElementById(selector) : null;

            if (!target) {
                return;
            }

            target.removeAttribute('data-interacted');

            if (target.classList.contains('extra-info-button-active')) {
                self.closeContent();
            } else {
                self.closeContent(function() {
                    if (tab) {
                        tab.classList.add('extra-info-tab-active');
                        target.classList.add('extra-info-button-active');
                    }
                });
            }

            trainingVM.updateVisited();
        };

        self.closeContent = function(callback) {
            var button = document.querySelector('.extra-info-button-active'),
                content = document.querySelector('.extra-info-tab-active');

            if (button) {
                button.classList.remove('extra-info-button-active');
            }

            if (content) {
                content.classList.remove('extra-info-tab-active');
            }

            if (typeof callback == 'function') {
                callback();
            }
        };

        self.fullsize = ko.computed(function() {
            var content = helpers.component.getContent(entityVM.componentsJSON(), 'ExtraInfoContent'),
                fullsize = content.fullsize;
                return fullsize;
        });

        self.launchers = ko.computed(function() {
            var ID = entityVM.ID(),
                entity = training.getContent(ID),
                launcher = helpers.component.getContent(entity.componentsJSON, 'ExtraInfoLauncher'),
                arr = helpers.component.parseProp(launcher, 'items', 'ExtraInfoItem');

            if (!arr.length) {
                return [];
            }

            var autoActivate1st = launcher.autoActivate1st,
                interacted = (userAnswers.isPageVisited(ID)) ? true : !launcher.interaction;

            arr.forEach(function(a, i) {
                a.active = (autoActivate1st && i === 0) ? true : false;
                a.interacted = (autoActivate1st && i === 0) ? 'true' : interacted.toString();
                a.selector = 'extra-tab-' + ID + '-' + i;
            });

            return arr;
        });

        self.contents = ko.computed(function() {
            var ID = entityVM.ID(),
                entity = training.getContent(ID),
                launcher = helpers.component.getContent(entity.componentsJSON, 'ExtraInfoLauncher'),
                content = helpers.component.getContent(entity.componentsJSON, 'ExtraInfoContent'),
                arr = helpers.component.parseProp(content, 'items', 'ExtraContentItem');

            if (!arr.length) {
                return [];
            }

            var autoActivate1st = launcher.autoActivate1st,
                closeButton = content.closeButton;

            arr.forEach(function(a, i) {
                a.ID = 'extra-tab-' + ID + '-' + i;
                a.active = (autoActivate1st && i === 0) ? true : false;
                a.closeButton = closeButton;
                a.img = (a.image) ? 'url(' + trainingVM.parseMediaURL(a.image) + ')' : '';
            });

            return arr;
        });
    };

});

